import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="108"
    viewBox="0 0 108 108"
    width="108"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <filter
      id="a"
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
      height="108"
      width="108"
      x="0"
      y="0"
    >
      <feFlood floodOpacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      />
      <feOffset dy="2" />
      <feGaussianBlur stdDeviation="5" />
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
      <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow" />
      <feBlend in="SourceGraphic" in2="effect1_dropShadow" mode="normal" result="shape" />
    </filter>
    <g filter="url(#a)">
      <rect height="88" rx="16" width="88" x="10" y="8" />
      <g strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
        <path d="m71.5668 62.3334v16.6666c0 2.2092-1.7909 4-4 4h-40.5668c-2.2091 0-4-1.7908-4-4v-33.3333c0-2.2092 1.7909-4 4-4h9.4334" />
        <path d="m36.4332 58.3333v-33.3333c0-2.2091 1.7908-4 4-4h12.4416c1.2927 0 2.5056.6247 3.2564 1.677l4.5454 6.3715c.7507 1.0523 1.9637 1.677 3.2563 1.677h17.0671c2.2091 0 4 1.7909 4 4v23.6078c0 2.2092-1.7909 4-4 4h-40.5668c-2.2092 0-4-1.7908-4-4z" />
      </g>
    </g>
  </svg>
);
